import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { Attendance, Fixture, Player } from "src/app/interfaces/Index";
import { FixtureService } from "src/app/services/Index";

type Props = {};
type State = {
	fixture: Fixture,
	potm: Player
};
export class ScoreboardPlayerOfTheMatch extends React.Component<Props, State> {
	
	constructor(props: Props) {
		super(props);
		this.state = {fixture: new Fixture,potm: new Player,};
	}

	componentDidMount() {
		this.getPlayer();		
		this.getFixture();
	}
	
	render() {
		return (
			<div id="scoreboard-wrapper2" style={{textAlign: "center", width:576, height:432}}>
				<Row>
				<h1 className="team-heading" style={{fontSize:50, marginBottom: 20}}>PLAYER OF THE MATCH</h1>
				</Row>
				<Row style={{height:"79%"}}>
				<Col style={{position: "relative"}}>
				<h1 style={{paddingLeft:20,paddingTop:20,float:"left",flex:0.3,flexDirection: "column",flexWrap: "wrap", alignContent: "center", whiteSpace: "break-spaces", textAlign: "center"}}>{this.state.potm.playerNumber}. {this.state.potm?.playerName}</h1>
				<br/>
				<div style={{position: "absolute",bottom:0, left:5,alignContent: "center", zIndex:99}}>
					<h4 style={{width:"100%"}}>SPONSORED BY:</h4>
				<img src={this.state.fixture?.matchSponsor?.imageDark} width="95%"/>
				</div>
				</Col>
				<Col style={{position: "relative"}}><img src={this.state.potm?.mugshotUrl} width="350" style={{position: "absolute",bottom:-20, right:20}}/></Col>
				</Row>				
				
			</div>
		);
	}

	async getPlayer(){
		const res = await safeJson(FixtureService.getPotm());
		if (res && res.error) {
		}
		// Nothing to show is not the same as nothing there: keep the empty
		// model rather than blanking a board mid-match.
		if (res) this.setState({potm: res});
	}

	async getFixture(){
		const res = await safeJson(FixtureService.getLatest());
		if (res && res.error) {
		}
		// Nothing to show is not the same as nothing there: keep the empty
		// model rather than blanking a board mid-match.
		if (res) this.setState({fixture: res});
	}
}